import AdvantageCardList from "@/components/advantageCard";
import {LBGhoverEffect} from "styles/hoverPresets";
import {ADVANTAGES_CONSTANTS} from "./constants";

const AdvantageComp = () => {
  return (
    <AdvantageCardList items={ADVANTAGES_CONSTANTS} hoverEffect hover={LBGhoverEffect} />
  );
};

export default AdvantageComp;
